export default "__VITE_ASSET__hU6WMZ5N__"